<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca45"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="consolidatedDeduction_search_button"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="consolidatedDeduction_statusQuery_button"
          @click="statusQuery"
        >
          更新扣款结果
        </el-button>
        <el-button
          v-if="getLimit('consolidatedDeduction_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="outTradeNo"
          title="交易流水号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.outTradeNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNo"
          title="网商支付订单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalAmount"
          title="金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="prePayFinishDate"
          title="完成时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.prePayFinishDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'prePayFinishDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorCode"
          title="错误码"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorDesc"
          title="错误描述"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorDesc"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="memo" title="备注" min-width="130" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.memo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="consolidatedDeduction_advancePayment_button"
            class="item"
            effect="dark"
            content="推进详情"
            placement="top"
          >
            <vxe-button type="text" @click="advancePayment(scope.row.code)">
              <em class="el-icon-finished" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              consolidatedDeduction_rePayment_button &&
                scope.row.status == 'FAIL'
            "
            class="item"
            effect="dark"
            content="重新支付"
            placement="top"
          >
            <vxe-button type="text" @click="rePayment(scope.row)">
              <em class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="ModelAllocateOil"
      title="推进支付"
      width="1000"
      height="800"
      resize
    >
      <AllocateOil ref="AllocateOilRef" @hideModel="hideModel" />
    </vxe-modal>
    <vxe-modal
      v-model="ModelCashMoney"
      title="重新支付"
      width="530"
      height="300"
      resize
    >
      <CashMoney ref="CashMoneyRef" @hideModel="hideModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import AllocateOil from "./components/allocateOil.vue";
import CashMoney from "./components/cashMoney.vue";
import { getBankPrepay, obtainPrepayQuery } from "@/api/InternetBanking";
import { getLimit } from "@/utils/getLimit.js";
export default {
  components: {
    AllocateOil,
    CashMoney
  },
  data() {
    return {
      exportObj: {
        exportUrl: "ntocc-tms-api/mybankPrepay/exportMyBankPrepay", //导出接口
        name: "合并明细"
      },
      ModelAllocateOil: false,
      ModelCashMoney: false,
      loading: false,
      consolidatedDeduction_search_button: false, //查询
      consolidatedDeduction_statusQuery_button: false, //更新扣款结果
      consolidatedDeduction_advancePayment_button: false, //推进详情
      consolidatedDeduction_rePayment_button: false, //重新支付
      tableData: [],
      listQuery: {
        prePayFinishDateRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      statusOptions: [
        { value: "SUCCESS", label: "成功" },
        { value: "FAIL", label: "失败" },
        { value: "DEALING", label: "处理中" },
        { value: "FINISHED", label: "已完成" }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.consolidatedDeduction_search_button = getLimit(
      "consolidatedDeduction_search_button"
    );
    this.consolidatedDeduction_statusQuery_button = getLimit(
      "consolidatedDeduction_statusQuery_button"
    );
    this.consolidatedDeduction_advancePayment_button = getLimit(
      "consolidatedDeduction_advancePayment_button"
    );
    this.consolidatedDeduction_rePayment_button = getLimit(
      "electronicReceipt_search_button"
    );
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getBankPrepay(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //支付状态查询
    statusQuery() {
      obtainPrepayQuery().then(response => {
        this.findList();
        if (response.status === 0) {
          this.$message({
            message: response.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: response.msg,
            type: "error"
          });
        }
      });
    },
    //重新支付
    rePayment(c) {
      this.$refs.CashMoneyRef.getInfo(c);
      this.ModelCashMoney = true;
    },
    //推进支付
    advancePayment(c) {
      this.$refs.AllocateOilRef.findList(c);
      this.ModelAllocateOil = true;
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    hideModel() {
      this.ModelCashMoney = false;
      this.findList();
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    }
  }
};
</script>
